import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICategoryCampaignQuery} from "../../models/category_campaign/query";
import {ICategoryCampaign, ICategoryCampaignDetails} from "../../models/category_campaign/response";
import {
    ICreateCategoryCampaign,
    IExportCategoryCampaignExcel,
    IUpdateCategoryCampaign
} from "../../models/category_campaign/request";
import {IExportCityExcel} from "../../models/city/request";
import {ICityQuery} from "../../models/city/query";
import axios from "axios";
import {ACCESS_TOKEN, LANGUAGE_CODE} from "../../utils/helpers/constants";

class CategoryCampaignService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllCategoriesCampaigns = (query: ICategoryCampaignQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<ICategoryCampaign>>({
            path: `/category`,
            method: "GET",
            query,
            ...params,
        });

    getCategoryCampaign = (id: number, params?: RequestParams) =>
        this.http.request<ICategoryCampaignDetails>({
            path: `/category/${id}`,
            method: "GET",
            ...params,
        });

    createCategoryCampaign = (data: ICreateCategoryCampaign, params?: RequestParams) =>
        this.http.request<ICategoryCampaign>({
            path: "/category",
            method: "POST",
            body: data,
            ...params,
        });

    updateCategoryCampaign = (
        id: number,
        data: IUpdateCategoryCampaign,
        params?: RequestParams
    ) =>
        this.http.request<ICategoryCampaign>({
            path: `/category/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteCategoryCampaign = (id: number, params?: RequestParams) =>
        this.http.request<ICategoryCampaign>({
            path: `/category/${id}`,
            method: "DELETE",
            ...params,
        });

    exportExcel = (data: IExportCategoryCampaignExcel, query: ICategoryCampaignQuery) =>
        axios.post(` ${process.env.REACT_APP_BASE_API_URL}/category/export`, data, {
            headers: {
                authorization: `Bearer ${
                    localStorage.getItem(ACCESS_TOKEN) ||
                    sessionStorage.getItem(ACCESS_TOKEN)
                }`,
                "Content-Type": "application/json",
                "accept-language": `${
                    localStorage.getItem(LANGUAGE_CODE) ??
                    process.env.REACT_APP_DEFAULT_LANGUAGE
                }`,
            },
            params: query,
            responseType: "arraybuffer",
        });

    updateCategoriesArrangementList = (id: number, data: {
        "priority":number
    }, params?: RequestParams) =>
        this.http.request({
            path: `/category/update-priority/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

}

export default CategoryCampaignService;
